import LoginPage from "./page/authentication/LoginPage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// import { AuthProvider} from './page/authentication/Auth';
// import PurchaseOperation from "./page/purchase/PurchaseOperation";
import PurchaseOperation from "./page/purchase/PurchaseOperationAdvanced";
import Sidebar from "./components/SidebarBeautiful";
// import Sidebar from "./components/SidebarTest";
import StockOperation from "./page/stock/StockOperation";
import PurchasesReport from "./page/purchase/PurchasesReport";
import SupplierReport from "./page/purchase/SupplierReport";
import SalePage from "./page/sale/SalePage";
import Signup from "./page/authentication/SignUp";
import Home from "./page/home/HomeDashBoard";
import SaleReport from "./page/sale/SaleReport";
import CustomerTranscationReport from "./page/sale/CustomerTransactionReport";
import Addproducts from "./page/stock/Addproducts";
import CashBook from "./page/cashbook/CashBook";
import EmployeeSetup from "./page/marketing/EmployeeSetup";
import MarketingDueCollection from "./page/marketing/MarketingDueCollection";
import ExpanceReport from "./page/income-expense/ExpenseReport";
import ExpanceInput from "./page/income-expense/ExpenseInput";
import Quotation from "./page/quotation/Quotation";
import { AuthProvider, useAuth } from "./page/authentication/Auth";
import DateBaseIncome from "./page/income-expense/DateBaseIncome";
import HelpContactPage from "./page/help and contact/HelpContactPage";
import MySupportTicket from "./page/help and contact/MySupportTicket";
import HiddenSaleReport from "./page/sale/HiddenSaleReport";
import PurchasesReportHidden from "./page/purchase/PurchasesReportHidden";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          {/* <Route
            path="/signup"
            element={<AdminProtectedRoute component={<Signup />} />}
          /> */}
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/home"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Home" />
                <ProtectedRoute component={<Home/>} />
              </div>
            }
          ></Route>
          <Route
            path="/purchase"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Purchase" />
                <ProtectedRoute component={<PurchaseOperation />} />
              </div>

            }
          ></Route>
          <Route
            path="/purchase/product-purchase-report"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Product Purchase Report" />
                <ProtectedRoute component={<PurchasesReport />} />
              </div>
            }
          ></Route>
          <Route
            path="/purchase/hidden/product-purchase-report"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Product Purchase Report Admin" />
                <AdminProtectedRoute component={<PurchasesReportHidden />} />
              </div>
            }
          ></Route>

          <Route
            path="/stock/stock-report"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Stock Report" />
                <ProtectedRoute component={<StockOperation />} />
              </div>
            }
          ></Route>
          <Route
            path="/purchase/supplier-transactions-report"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Supplier Transactions Report" />
                <AdminProtectedRoute component={<SupplierReport />} />
              </div>
            }
          ></Route>
          <Route
            path="/salepage"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Sale Page" />
                <ProtectedRoute component={<SalePage />} />
              </div>
            }
          ></Route>
          <Route
            path="/stock/addproduct"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Product" />
                <ProtectedRoute component={<Addproducts />} />
              </div>
            }
          ></Route>
          <Route
            path="/sale/product-sale-report"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Product Sale Report" />
                <ProtectedRoute component={<SaleReport />} />
              </div>
            }
          ></Route>
          <Route
            path="/sale/hidden/product-sale-report"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Product Sale Report Admin" />
                <AdminProtectedRoute component={<HiddenSaleReport />} />
              </div>
            }
          ></Route>
          <Route
            path="/sale/customer-transactions-report"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Customer Transactions Report" />
                <ProtectedRoute component={<CustomerTranscationReport />} />
              </div>
            }
          ></Route>
          <Route
            path="/cashbook"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Cashbook" />
                <AdminProtectedRoute component={<CashBook />} />
              </div>
            }
          ></Route>
          <Route
            path="/income-expense/expense-input"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Expense Input" />
                <AdminProtectedRoute component={<ExpanceInput />} />
              </div>
            }
          ></Route>
          <Route
            path="/income-expense/expense-report"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Expense Report" />
                <AdminProtectedRoute component={<ExpanceReport />} />
              </div>
            }
          ></Route>
          <Route
            path="/income-expense/profit-loss"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Profit/Loss" />
                <AdminProtectedRoute component={<DateBaseIncome />} />
              </div>
            }
          ></Route>
          <Route
            path="/quotation"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Quotation" />
                <AdminProtectedRoute component={<Quotation />} />
              </div>
            }
          ></Route>
          <Route
            path="/marketing/marketing-due-collection"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Marketing Due Collection" />
                <AdminProtectedRoute component={<MarketingDueCollection />} />
              </div>
            }
          ></Route>
          <Route
            path="/marketing/employee-setup"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Employee Setup" />
                <AdminProtectedRoute component={<EmployeeSetup />} />
              </div>
            }
          ></Route>
          <Route
            path="/help-center/open-support-ticket"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Open Ticket Support" />
                <AdminProtectedRoute component={<HelpContactPage />} />
              </div>
            }
          ></Route>
          <Route
            path="/help-center/my-support-ticket"
            element={
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Sidebar pageName="Open Ticket Support" />
                <AdminProtectedRoute component={<MySupportTicket />} />
              </div>
            }
          ></Route>

        </Routes>
      </AuthProvider>
    </Router>
  );
}
const ProtectedRoute = ({ component }) => {
  const { isLoggedIn } = useAuth();

  return isLoggedIn ? component : <Navigate to="/" replace />;
};

const AdminProtectedRoute = ({ component }) => {
  const admin = localStorage.getItem("role");
  const { isLoggedIn } = useAuth();

  return isLoggedIn && admin === "ROLE_ADMIN" ? (
    component
  ) : (
    <Navigate to="/" replace />
  );
};
export default App;
